import React from "react";

export const tableCustomTotal = (from, to, size) => <span className="react-bootstrap-table-pagination-total ml-4">
        Options (
{from}-
{to}) of 
{' '}
{size}
    </span>
;

export const tablePageOptions = (length, isStockOrder) => {

    const pageArray = [
        {
            "text": "10",
            "value": 10
        },
        {
            "text": "15",
            "value": 15
        },
        {
            "text": "25",
            "value": 25
        },
        {
            "text": "50",
            "value": 50
        }
    ];

    if (isStockOrder) {

        pageArray.push({"text": "All",
            "value": length});

    }
    return {
        "hideSizePerPage": false,
        "alwaysShowAllBtns": true,
        "showTotal": true,
        "paginationTotalRenderer": tableCustomTotal,
        "sizePerPageList": pageArray
    };

};
